import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'
import getFieldFromItem, { fieldLang, getFieldWithLangKey, getNewObjFromDirtyLangObj } from '../utils/getFieldFromItem'

export const keys = []

export const editForm = formFieldsChange => ({
  type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_ENTER_RESET,
})

export const fetchItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_FETCHITEM_LOAD })
  try {
    let item = await api.get(`cv_appointments_and_public_offices/${params.id}`)
    item = {
      ...item,
      ...getFieldWithLangKey({ fieldTitle: 'data', objString: item.data, languages: fieldLang }),
    }
    dispatch({
      type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_FETCHITEM_SUCCEED,
      item,
    })
    const field = getFieldFromItem(
      item,
      //keys,
    )
    dispatch({
      type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_EDITFORM_CHANGE,
      field,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_FETCHITEM_FAIL,
      fetchItemError: error.message,
    })
  }
}

export const createItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_CREATEITEM_LOAD })
  try {
    await api.create(`cv_appointments_and_public_offices`, getNewObjFromDirtyLangObj({ fieldTitle: 'data', languages: fieldLang, obj: params }))
    dispatch({ type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICELIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_CREATEITEM_FAIL,
      createItemError: error.message,
    })
  }
}

export const editItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_EDITITEM_LOAD })
  try {
    await api.patch(`cv_appointments_and_public_offices/${params.id}`, getNewObjFromDirtyLangObj({ fieldTitle: 'data', languages: fieldLang, obj: params }))
    dispatch({ type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_EDITITEM_SUCCEED })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_EDITITEM_FAIL,
      editItemError: error.message,
    })
  }
}

export const deleteItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_DELETEITEM_LOAD })
  try {
    await api.delete(`cv_appointments_and_public_offices/${params.id}`)
    dispatch({ type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.CV_APPOINTMENTS_AND_PUBLIC_OFFICEFORM_DELETEITEM_FAIL,
      deleteItemError: error.message,
    })
  }
}
